const redDanger = "rgba(245,72,25,.85)"
const mediumSeaGreen = "#20af66"
const errorColor = "#f44b4b"
const black = "black"
const white = "white"
const ghostwhite = "ghostwhite"
const grey = "grey"
const darkgrey = "darkgrey"
const dimgrey = "dimgrey"
const lightgrey = "lightgrey"
const deepskyblue = "deepskyblue"
const slategrey = "slategrey"
const lightslategrey = "lightslategrey"
const lightGreen = "#74bd4a"
const darkorange = "darkorange"

export const DarkTheme = {
    layoutSizes: {
        menuWidth: 250,
        projectMenuWidth: 200,
        sidebarWidth: 63,
        headerHeight: 63,
        footerHeight: 63,
    },
    fontSizes: {
        xs: 12,
        sm: 13,
        md: 14,
        lg: 16,
        xl: 18,
    },
    openSans: "Open Sans",
    defaultFont: "\"Helvetica Neue\", Helvetica, sans-serif, Lato, Arial",
    defaultTransition: "0.2s ease",

    layoutBackground: "#22262b",
    headerBackground: "#22262b",
    defaultTextColor: ghostwhite,
    defaultLinkColor: ghostwhite,
    defaultLinkHoverColor: darkgrey,
    defaultErrorColor: errorColor,
    footerColor: darkgrey,

    scrollbarSize: 10,
    scrollbarTrack: "#2b2f33",
    scrollbarThumb: "#1c1e23",
    scrollbarThumbHover: "#161719",

    spinnerColor: grey,
    spinnerBackground: "rgba(56, 62, 68, 0.5)",

    lostConnectionWrapperBackground: "rgba(56, 62, 68, 0.5)",
    lostConnectionMessageBackground: "rgb(175 29 33 / 70%)",
    lostConnectionMessageColor: white,

    loginPageBackground: "#303338",
    loginInputBackground: "#1c1e23",
    loginInputColor: "#65676d",
    loginInputFocusColor: ghostwhite,
    loginInputPlaceholderColor: "#7b736b",
    loginBoxShadowColor: darkgrey,
    loginAccountConfirm: grey,
    loginLinkColor: "#7c7e83",
    loginLinkActiveColor: ghostwhite,

    goToLoginLinkColor: "#7592b1",
    goToLoginLinkActiveColor: "#a3c2e3",

    menuBackground: "#2f3338",
    menuItemColor: ghostwhite,
    menuItemBackground: "#2f3338",
    menuItemHoverBackground: "#373c42",
    menuItemActiveBackground: "#3f444a",
    menuItemBorderTopColor: "#3c4248",
    menuItemBorderBottomColor: "#23282d",
    menuSubItemColor: "#c7c7c7",
    menuSubItemBackground: "#282c31",
    menuSubItemHoverBackground: "#23262b",
    menuSubItemActiveBackground: "#1f2227",

    projectMenuBackground: "#2c3035",
    projectMenuBorderColor: "#272b2f",
    projectMenuItemColor: lightgrey,
    projectMenuItemBackground: "#2c3035",
    projectMenuItemHoverBackground: "#31363b",
    projectMenuItemActiveBackground: "#383e44",
    projectMenuItemBorderBottomColor: "#25272d",
    projectMenuSubItemColor: "#a7a7a7",
    projectMenuSubItemBackground: "#262a2f",
    projectMenuSubItemHoverBackground: "#222529",
    projectMenuSubItemActiveBackground: "#1e2227",

    sidebarBackground: "#1c1e23",
    sidebarHelpBackground: "rgba(66, 72, 78, 0.7)",
    sidebarHelpColor: ghostwhite,
    sidebarHelpEditBlockBackground: "#282c31",
    sidebarHelpEditBlockBorderColor: "#1c1e23",
    sidebarHelpLinkColor: "deepskyblue",
    sidebarHelpLinkHoverColor: "royalblue",

    profileTextColor: lightgrey,
    profileDropdownShowBackground: "rgba(130, 142, 158, 0.2)",
    profileDropdownMenuColor: lightgrey,
    profileDropdownMenuHoverColor: ghostwhite,
    profileDropdownMenuBackground: "#22262b",
    profileDropdownMenuHoverBackground: "hsla(0, 0%, 54%, 0.1)",

    pageHeaderHeight: 50,
    pageHeaderBackground: "#383e44",
    pageHeaderBorderColor: "#303338",
    pageLayoutBackground: "#2b3035",
    pageContentBackground: "#383e44",

    pageMenuBackground: "#22262b",
    pageMenuButtonColor: darkgrey,
    pageMenuButtonColorActive: ghostwhite,
    pageMenuButtonBackgroundHover: "rgb(138, 138, 138, 0.05)",
    pageMenuButtonBackgroundActive: "rgb(138, 138, 138, 0.1)",
    pageMenuDropdownBackground: "#22262b",
    pageMenuDropdownItemColor: darkgrey,
    pageMenuDropdownItemColorHover: ghostwhite,
    pageMenuDropdownItemBackgroundHover: "hsla(0, 0%, 54%, 0.05)",

    delimeterColor: "#50555a",

    modalBackground: "rgba(0, 0, 0, 0.4)",
    modalCloseButtonBackground: "#2fc6f6",
    modalCloseButtonBorderColor: "rgba(255, 255, 255, 0.45)",

    billingModalBackground: "#383e44",
    billingModalTitleColor: ghostwhite,
    billingModalSubtitleColor: darkgrey,

    cartNumberBackground: "orangered",
    cartEmptyIconColor: mediumSeaGreen,
    cartItemBackground: "#25292e",
    cartItemTitleColor: ghostwhite,
    cartItemInfoColor: grey,
    cartItemButtonColor: grey,
    cartItemButtonHoverColor: lightgrey,
    cartPriceColor: ghostwhite,

    checkoutButtonBackground: mediumSeaGreen,
    checkoutButtonColor: white,
    availablePackageBackground: `
        linear-gradient(309deg, rgb(33 56 39 / 70%), rgba(255,0,0,0) 70%),
        linear-gradient(170deg, rgb(24 27 30 / 75%), rgba(0,255,0,0) 70%),
        linear-gradient(203deg, rgb(24 45 120 / 85%), rgba(0,0,255,0) 70%),
        linear-gradient(7deg, rgb(41 46 43 / 70%), rgba(255,0,0,0) 70%)
    `,
    availablePackageNameAfter: "darkslategrey",
    availablePackageButtonBackground: mediumSeaGreen,

    billingHistoryTitleBackground: "#2f3338",
    billingHistoryBodyBackground: "#42484e",
    billingHistoryBorderColor: "black",
    billingHistoryItemBackground: "#2f3338",
    billingHistoryItemTitleColor: ghostwhite,
    billingHistoryItemInfoColor: grey,
    billingHistoryPriceColor: ghostwhite,

    tableColor: lightgrey,
    tableHeaderAfterBackground: "rgba(157, 163, 169, 0.4)",
    tableRowBackground: "#42484e",
    tableRowHoverBackground: "#4c5358",
    tableRowSelectedBackground: "#343a3f",
    tableRowSelectedHoverBackground: "#2e3438",
    tableRowBorderColor: "#4c5358",
    tableCellDangerBackground: "rgb(255 68 68 / 30%)",
    tableBottomBorderColor: "#24262c",
    tableEditableCellBorderColor: mediumSeaGreen,
    tableSortControlColor: darkgrey,
    tableSettingsButtonColor: lightgrey,
    tablePageButtonColor: darkgrey,
    tablePageButtonActiveColor: ghostwhite,
    tablePrevNextButtonColor: lightgrey,
    tablePrevNextButtonInactiveColor: grey,
    tableInfiniteColor: darkorange,

    tablePopoverBackground: "#1c1e23",
    tablePopoverColor: ghostwhite,

    tableCollapseButtonColor: "#bacedc",
    tableSectionColor: ghostwhite,
    tableSectionNotUsedColor: lightgrey,

    tableSectionMinorBackground: "#7498ad",
    tableSectionMinorBackgroundHover: "#79a3bb",
    tableSectionMinorBorderColor: "#8cb3ca",

    tableSectionMinorDropdownBackground: "#5d7d8f",
    tableSectionMinorDropdownColor: ghostwhite,

    tableSectionSecondaryBackground: "#5e7a8c",
    tableSectionSecondaryBackgroundHover: "#62869c",
    tableSectionSecondaryBorderColor: "#708a9a",

    searchInputBackground: "#545b60",
    searchInputColor: darkgrey,
    searchInputFocusColor: ghostwhite,
    searchInputPlaceholderColor: darkgrey,

    searchInputClearSearch: grey,
    searchInputClearSearchHover: darkgrey,

    searchFilterBackground: "#1e2227",
    searchFilterColor: ghostwhite,
    searchFilterCloseButtonColor: dimgrey,
    searchFilterCloseButtonHoverColor: grey,

    searchPopupFilterBackground: "#50555a",
    searchPopupFilterColorActive: deepskyblue,
    searchPopupFilterBorderRightColor: "#4d4e4e",
    searchPopupFilterBorderBottomColor: "#63676d",
    searchPopupFormBackground: "#42484e",

    dangerButtonBackground: redDanger,
    dangerButtonColor: white,
    successButtonBackground: mediumSeaGreen,
    successButtonColor: white,
    primaryButtonBackground: "#22262b",
    primaryButtonColor: ghostwhite,

    sliderSwitcherActiveBackground: mediumSeaGreen,
    sliderSwitcherInactiveBackground: grey,
    sliderSwitcherButtonColor: ghostwhite,

    helpColor: grey,

    listItemBackground: "#50555a",

    dangerAlertBackground: "rgb(245 72 25 / 60%)",
    dangerAlertColor: "darkred",
    successAlertBackground: "rgb(32 175 102 / 45%)",
    successAlertColor: "#003800",
    primaryAlertBackground: "rgb(57 167 231 / 65%)",
    primaryAlertColor: "#00006a",
    warningAlertBackground: "rgb(219 195 107 / 80%)",
    warningAlertColor: "#684d00",

    updateButtonBackground: "#cf9a07",
    updateButtonColor: ghostwhite,

    linkButtonColor: grey,
    linkButtonHoverColor: lightgrey,

    textButtonColor: ghostwhite,

    deleteButtonIdleColor: dimgrey,
    deleteButtonIdleHoverColor: darkgrey,
    deleteButtonSpinnerColor: grey,

    buttonGroupActiveBackground: "#22262b",
    buttonGroupActiveColor: ghostwhite,
    buttonGroupInactiveBackground: "#2a3035",
    buttonGroupInactiveColor: darkgrey,
    buttonGroupBorderColor: "#1c1e23",

    statusSwitcherActiveColor: mediumSeaGreen,
    statusSwitcherInactiveColor: dimgrey,
    statusSwitcherUnconfirmedColor: darkorange,
    statusSwitcherPublishedColor: "#1691f0",
    statusSwitcherUnpublishedColor: dimgrey,
    statusSwitcherLoaderColor: grey,

    tooltipBackground: black,
    tooltipColor: ghostwhite,
    tooltipCloseColor: dimgrey,
    tooltipCloseHoverColor: darkgrey,

    userIconTextColor: lightgrey,
    userIconSystemInactiveColor: darkorange,
    userIconProjectInactiveColor: "deepskyblue",

    dateFormatterColor: darkgrey,

    feedbackDanger: errorColor,
    feedbackSuccess: mediumSeaGreen,

    labelColor: ghostwhite,
    labelButtonColor: grey,
    labelButtonHoverColor: "#a9a9a9",
    labelButtonHoverBorderColor: grey,

    inputBackground: "#50555a",
    inputColor: darkgrey,
    inputFocusColor: ghostwhite,
    inputPlaceholder: "#777777",

    selectDropdownBackground: "#22262b",
    selectDropdownHoverBackground: "hsla(0, 0%, 54%, 0.1)",
    selectDropdownItemColor: lightgrey,
    selectDropdownItemHoverColor: ghostwhite,
    selectDropdownSearchBackground: "#373c42",
    selectDropdownClearSearch: grey,
    selectDropdownClearSearchHover: darkgrey,
    selectDropdownDelete: dimgrey,
    selectDropdownDeleteHover: darkgrey,

    colorPickerSelectedColor: grey,

    fileLoaderBorderColor: "#50555a",
    fileLoaderTitleColor: darkgrey,
    fileLoaderTitleHoverColor: lightgrey,
    fileLoaderButtonBackground: "#22262b",
    fileLoaderButtonHoverBackground: "#272c32",
    fileLoaderButtonColor: darkgrey,
    fileLoaderButtonHoverColor: lightgrey,

    radioButtonActiveColor: mediumSeaGreen,
    radioButtonInactiveColor: dimgrey,
    radioButtonSpinnerColor: grey,

    collapseTitleBackground: "#282c31",
    collapseTitleBackgroundHover: "#23262b",
    collapseTitleBorderTopColor: "#353b41",
    collapseTitleBorderBottomColor: black,
    collapseTitleColor: lightgrey,
    collapseBodyBackground: "rgb(255 255 255 / 2%)",
    collapseBodyBorderColor: "#464d54",

    permissionBorderBottomColor: grey,
    permissionLabelColor: grey,

    userDropdownBackground: "#50555a",
    userDropdownColor: ghostwhite,
    userDropdownMenuBackground: "#22262b",
    userDropdownMenuBackgroundHover: "hsla(0, 0%, 54%, 0.1)",

    accountDropdownBackground: "#50555a",
    accountDropdownColor: ghostwhite,
    accountDropdownMenuBackground: "#22262b",
    accountDropdownMenuBackgroundHover: "hsla(0, 0%, 54%, 0.1)",

    nestedListParagraphBackground: "#383e44",
    nestedListParagraphBorderColor: dimgrey,
    nestedListParagraphCollapseColor: mediumSeaGreen,
    nestedListItemBorderColor: dimgrey,
    nestedListItemBackgroundColor: "#50555a",
    nestedListMenuButtonColor: grey,
    nestedListMenuButtonColorHover: darkgrey,

    popupMenuBackground: "#50555a",
    popupMenuBackgroundHover: "#595f65",
    popupMenuColor: white,
    popupMenuBoxShadow: "0 6px 16px rgb(0 0 0 / 50%), 0 -1px 6px 0 rgb(0 0 0 / 40%)",
    popupMenuBoxShadowBottom: "0 8px 12px rgb(0 0 0 / 50%), 0 4px 6px 0px rgb(0 0 0 / 40%)",
    popupMenuBoxShadowTop: "0 -2px 6px rgb(0 0 0 / 40%), 0 -4px 6px 0px rgb(0 0 0 / 20%)",
    popupMenuBoxShadowRight: "8px 6px 12px rgb(0 0 0 / 50%), 4px 0px 8px 0 rgb(0 0 0 / 40%)",
    popupMenuBoxShadowLeft: "-8px 6px 12px rgb(0 0 0 / 50%), -4px 0px 8px 0 rgb(0 0 0 / 40%)",

    confirmWrapperBackground: "rgba(0,0,0,.6)",
    confirmBackground: "#383e44",
    confirmDescriptionColor: darkgrey,

    driveToolbarBackgroundColor: "#383e44",
    driveToolbarBorderColor: "#303338",
    driveToolbarImageColor: grey,
    driveToolbarColor: lightgrey,
    driveToolbarCloseButtonColor: dimgrey,
    driveToolbarCloseButtonColorHover: darkgrey,
    driveToolbarListStyleBorderColor: dimgrey,
    driveToolbarListStyleBackground: "#22262b",

    driveSortBorderColor: "#383e45",
    driveSortReverseColor: mediumSeaGreen,

    driveElementBorderColor: grey,
    driveListElementBorderColor: dimgrey,
    driveElementBackgroundColor: "#454b50",
    driveElementBackgroundColorHover: "#515a61",
    driveElementBackgroundColorSelected: "rgba(0,149,255,.35)",
    driveElementBackgroundColorSelectedHover: "rgb(16 176 255 / 45%)",
    driveElementMenuButtonColor: grey,
    driveElementMenuButtonColorHover: darkgrey,
    driveElementCheckboxBackgroundColor: white,
    driveElementCheckboxBorderColor: grey,
    driveElementCheckboxColor: black,
    driveListElementFileIconBackground: "#22262b",
    driveRenameInputColor: black,
    driveRenameInputBackgroundColor: ghostwhite,

    driveNewFileBorderColor: "#50555a",
    driveNewFileSuccessColor: mediumSeaGreen,
    driveNewFileErrorColor: errorColor,
    driveNewFileInProgressColor: lightgrey,

    driveAmazonIconColor: "orange",
    driveGoogleIconColor: "orangered",
    driveMicrosoftIconColor: "dodgerblue",

    driveCloudButtonSpinnerColor: grey,
    driveCloudModalSecretsBackground: "#383e44",
    driveCloudModalSecretsBoxShadow: "-2px 5px 16px -2px #000",

    driveEmptyButtonColor: slategrey,
    driveEmptyButtonHoverColor: lightgrey,
    driveEmptyButtonHoverBackground: "rgba(255,255,255, 0.08)",

    driveMoveToBackground: "#2b2f33",
    driveMoveToCollapseColor: grey,
    driveMoveToSelectedBackground: "rgba(0,0,0, 0.5)",
    driveMoveToSelectedColor: ghostwhite,

    nestedHistoryBackgroundColor: "#50555a",
    nestedHistoryColor: lightgrey,
    nestedHistoryTitleColor: "#8a8a8a",
    nestedHistoryTitleBorderColor: darkgrey,
    nestedHistoryAuthorColor: ghostwhite,
    nestedHistoryApprovalLevelColor: darkgrey,
    nestedHistoryWorkflowColor: darkgrey,
    nestedHistoryBoldColor: ghostwhite,

    statisticNotStarted: grey,
    statisticInProgress: mediumSeaGreen,
    statisticFailed: errorColor,
    statisticApproved: lightGreen,
    statisticValue: ghostwhite,

    mailSettingsBorderColor: "#5a5e62",
    mailSettingsHoverBackground: "rgba(0,0,0, 0.1)",
    mailSettingsValueColor: darkgrey,

    lifecycleInspectorBackgroundColor: "#303338",
    lifecycleInspectorEmptyColor: "grey",
    lifecycleBreadCrumbsBackgroundColor: "#282c31",

    tagBackground: "#236ca9",
    tagColor: ghostwhite,
    tagCloseButtonColor: darkgrey,
    tagCloseButtonHoverColor: ghostwhite,
    tagCreateFromSearchColor: grey,

    qidModelOptionBackground: "#2d3035",
    qidModelLineTreeBackground: "rgba(157, 163, 169, 0.4)",
    qidModelCollapseColor: mediumSeaGreen,

    qidDatapointBorderColor: "#1c1e23",
    qidDatapointTitleBackground: "#2f3338",
    qidDatapointAddButtonBackground: "#22262b",
    qidDatapointNewStatus: mediumSeaGreen,
    qidDatapointNewBackground: "rgb(30 120 45 / 20%)",
    qidDatapointNewHoverBackground: "rgb(39 185 63 / 20%)",
    qidDatapointDeleteStatus: grey,
    qidDatapointDeleteBackground: "rgb(33 34 36 / 20%)",
    qidDatapointDeleteHoverBackground: "rgb(79 80 80 / 20%)",

    qidResultDatapointWrapperBackground: "#383e44",

    silModelWrapperBackground: "#2b2f34",
    silModelBlockWrapperBorderColor: lightslategrey,
    silModelButtonColor: grey,
    silModelButtonHoverColor: lightgrey,
    silModelChangeButtonBackground: "rgb(53 63 73 / 80%)",

    silResultCalculateButtonBackground: deepskyblue,
    silResultTabBackground: "#32383e",
    silResultTabBackgroundHover: "#2c3136",
    silResultTabBackgroundActive: "#282c31",
    silResultTableBorderColor: slategrey,
    silResultTableHeaderBackground: "rgb(112 128 144 / 35%)",

    silUpdateDangerRowBackground: "rgb(255 51 51 / 60%)",

    fireIconActiveColor: darkorange,
    fireIconInactiveColor: grey,
    highPriorityActiveColor: ghostwhite,
    highPriorityInactiveColor: grey,

    deadlineEmptyBackground: grey,
    deadlineEmptyColor: lightgrey,
    deadlineBackground: "#119b93",
    deadlineOverdueBackground: "#cf605d",
    deadlineColor: white,

    pendingReviewBackground: "#dda847",
    pendingReviewColor: "#895618",

    deferredBorderColor: lightgrey,
    deferredColor: lightgrey,

    taskStateHeaderBackground: "#39b6c5",
    taskStateHeaderColor: white,

    taskStatusBackground: "#236ca9",
    taskStatusColor: ghostwhite,
    taskStatusCloseButtonColor: darkgrey,
    taskStatusCloseButtonHoverColor: ghostwhite,

    taskStatusClearButtonBackground: dimgrey,
    taskStatusClearButtonHoverBackground: grey,
    taskStatusClearButtonColor: darkgrey,
    taskStatusClearButtonHoverColor: lightgrey,

    taskOverdueBackground: "rgb(235 55 55 / 60%)",
    taskOverdueColor: lightgrey,

    attachmentBlockManagerButtonColor: darkgrey,
    attachmentBlockManagerButtonHoverColor: grey,

    attachmentBlockBackgroundColor: "#50555a",
    attachmentBackgroundColor: ghostwhite,
    attachmentTextColor: dimgrey,
    attachmentInTextColor: "#2fc6f6",
    attachmentInTextBoxShadow: "0 0 0 2px #2fc6f6",
    attachmentHoverBoxShadow: "0 8px 14px 0 rgba(0,0,0,0.8)",

    newCommentColor: grey,
    newCommentHoverColor: darkgrey,
    commentBackgroundColor: "#464b50",
    commentAuthorColor: "#7f99b3",
    commentActionButtonColor: grey,

    commentCollapseDescriptionBackground: `linear-gradient(to bottom,rgb(70 75 80 / 0%),
        rgb(70 75 80 / 80%) 7px,rgb(70 75 80) 14px)`,
    commentCollapseDescriptionBorderColor: "#383e44",
    commentCollapseDescriptionBorderHoverColor: "#22262b",

    sessionTableBorderColor: "#2b2f33",
    sessionTimelineBackground: "repeating-linear-gradient(90deg,#4c5358,#4c5358 60px,#42484e 60px,#42484e 120px)",
    sessionTodayMarkerColor: redDanger,
    sessionStatusDescriptionColor: darkgrey,
    sessionConfirmDeadlineDescription: darkgrey,
    sessionConfirmDeadlineKeyResultBorder: dimgrey,

    keyResultTableRowBorderHoverColor: "#5c646b",
    keyResultTypeColor: darkgrey,
    keyResultDeadlineColor: grey,
    keyResultDeadlineDescriptionColor: darkgrey,
    keyResultMetricBackground: "#22262b",
    keyResultMetricColor: darkgrey,

    confidenceLowBackground: "#d79927",
    confidenceMediumBackground: "#217ad1",
    confidenceHighBackground: mediumSeaGreen,

    keyResultUpdateEmptyListClock: dimgrey,
    keyResultUpdateEmptyListSubtitle: darkgrey,
    keyResultUpdateEmptyListButtonColor: mediumSeaGreen,

    keyResultUpdateBorderColor: dimgrey,
    keyResultUpdateClock: "indianred",
    keyResultUpdateNote: darkgrey,

    keyResultUpdateOptionsBackground: "transparent",
    keyResultUpdateOptionsHoverBackground: "#50555a",
    keyResultUpdateOptionsColor: grey,
    keyResultUpdateOptionsHoverColor: darkgrey,

    keyResultUpdatePercentsChangeZeroBackground: "#818181",
    keyResultUpdatePercentsChangeMinusBackground: "#c15e44",
    keyResultUpdatePercentsChangeMinusColor: "#8d1717",
    keyResultUpdatePercentsChangePlusBackground: "#48ab79",
    keyResultUpdatePercentsChangePlusColor: "#0d6137",

    keyResultUpdatePercentsSummColor20: "#cf6a6a",
    keyResultUpdatePercentsSummColor40: "#9e81db",
    keyResultUpdatePercentsSummColor70: "#69abeb",
    keyResultUpdatePercentsSummColor100: "#35d1a5",
    keyResultUpdatePercentsSummColor: "#d79dd7",

    keyResultGraphTitleBorderColor: dimgrey,

    keyResultGraphSuccessSection: "#5aad9c",
    keyResultGraphCriticalSection: "#bbac7d",
    keyResultGraphFailSection: "#c79497",

    keyResultGraphGridColor: "#5f5f5f",
    keyResultGraphSoftDeadlineColor: "orange",
    keyResultGraphSoftDeadlineBackground: "#9c7222",
    keyResultGraphHardDeadlineColor: "orangered",
    keyResultGraphHardDeadlineBackground: "#742b2f",
    keyResultGraphUpdateColor: "rgb(0 129 255)",
    keyResultGraphUpdateFillColor: "rgb(30 144 255 / 20%)",
    keyResultGraphAchievedColor: "rgb(72, 171, 121)",
    keyResultGraphNotAchievedColor: "indianred",
    keyResultGraphTargetColor: darkgrey,
    keyResultGraphCrossLineColor: lightgrey,

    keyResultGraphTooltipBackground: "#232323",
    keyResultGraphTooltipPointUpdate: "rgb(30 144 255)",
    keyResultGraphTooltipPointTarget: grey,
    keyResultGraphTooltipPointAchieved: "rgb(72, 171, 121)",
    keyResultGraphTooltipPointNotAchieved: "indianred",
    keyResultGraphTooltipDiffAboveZeroColor: mediumSeaGreen,
    keyResultGraphTooltipDiffZeroColor: "blue",
    keyResultGraphTooltipDiffBelowZeroColor: "red",

    rrsCategoryWarningColor: errorColor,
    rrsLabelBorderColor: dimgrey,
    rrsDeleteButtonColor: grey,
    rrsDeleteButtonColorHover: lightgrey,
    rrsCollapseButtonColor: grey,
    rrsNestedCategoryButtonColor: dimgrey,
    rrsNestedCategoryButtonHoverColor: darkgrey,
    rrsRiskMapTableBorderColor: "rgb(80, 85, 90)",
    rrsRiskMapTableHeaderBackground: "#2d3035",

    markovVariableColor: mediumSeaGreen,
    markovVariableFocusColor: "#20d77a",
}

export type Theme = typeof DarkTheme
